
import {
  SECTION,
  GRID,
  CELL,
  WIDGET,
  SLIDE_SECTION,
  SLIDE_PAGE,
  SLIDE_CONTAINER,
  PAGE,
} from "@model/components/componentMeta.model";
import layoutConfigs from "@model/layoutConfigs/layoutConfigs"
import { responsiveFontSize } from "@helpers/text.helper";
import gridLayoutConfig from "@model/layoutConfigs/grid";

const getComponentMeta = (componentID) => {
  const typeList = [SECTION,
    SLIDE_SECTION,
    SLIDE_PAGE,
    SLIDE_CONTAINER,
    GRID,
    CELL,
    WIDGET]
  return typeList.filter(type => componentID.search(type.prefixKey) == 0)[0]

}
const cloneComponent = ({ components, component_id }) => {
  const child = components[component_id].componentsID
  const childHover = components[component_id].componentsIDHover || null // interavtive
  let childClone = []
  let childObject = {}

  if (child && Array.isArray(child) && child.length > 0) {
    child.forEach(child_id => {
      childClone.push(cloneComponent({ components, component_id: child_id, parent_id: component_id }))
    })
    childClone.forEach(child => {
      childObject = { ...childObject, ...child.object }
    })
  }

  if (childHover && Array.isArray(childHover) && childHover.length > 0) {
    childHover.forEach(child_id => {
      childClone.push(cloneComponent({ components, component_id: child_id, parent_id: component_id }))
    })
    childClone.forEach(child => {
      childObject = { ...childObject, ...child.object }
    })
  }


  let componentClone = JSON.parse(JSON.stringify(components[component_id]))
  const prevID = componentClone.id
  const randomkey = `${Math.random()
    .toString(36)
    .substring(4)}`;
  const key = `${prevID.slice(0, 3)}${randomkey.substring(
    randomkey.length - 4,
    randomkey.length
  )}`;
  if(componentClone.type == 'SECTION'){
    componentClone.properties.name = componentClone.properties.name + '(copy)'
  }
  componentClone.id = key
  const childKey = childClone.map(a => ({ key: a.key, prevKey: a.prevKey }))
  if (componentClone.componentsID) {
    childKey.forEach(({ prevKey, key }) => {
      const index = componentClone.componentsID.indexOf(prevKey)
      componentClone.componentsID[index] = key
    })
  }
  // interavtive
  if (componentClone.componentsIDHover) { 
    childKey.forEach(({ prevKey, key }) => {
      const index = componentClone.componentsIDHover.indexOf(prevKey)
      componentClone.componentsIDHover[index] = key
    })
  }
  if (componentClone.componentsIDMobile) {
    childKey.forEach(({ prevKey, key }) => {
      const index = componentClone.componentsIDMobile.indexOf(prevKey)
      componentClone.componentsIDMobile[index] = key
    })
  }
  return {
    prevKey: prevID,
    key,
    object: {
      [key]: componentClone,
      ...childObject
    },
  }
}

const component2Mock = (components, componentID) => {
  let render = {
    ids: {},
    components: {},
    type: {},
  }

  const is_cell = componentID.search(CELL.prefixKey) == 0
  if (is_cell) {
    const parent = findParentComponent(components, componentID)
    componentID = parent[1]
  }
  const is_slide_container = componentID.search(SLIDE_CONTAINER.prefixKey) == 0
  if (is_slide_container) {
    const parent = findParentComponent(components, componentID);
    componentID = parent[0];
  }

  render.type = getComponentMeta(componentID)
  if (components[componentID].type == "SLIDE_SECTION") {
    render.type = SLIDE_SECTION
  }

  const recursiveComponent = (id) => {
    const targetComponent = components[id]
    if (!render.ids[targetComponent.type]) {
      render.ids[targetComponent.type] = []
    }
    if (render.ids[targetComponent.type].indexOf(targetComponent.id) == -1) {

      render.ids[targetComponent.type].push(targetComponent.id)
      render.components[targetComponent.id] = targetComponent
      const childAttr = Object.keys(targetComponent).filter(attr => attr.search('componentsID') > -1)
      childAttr.forEach(attr => {
        if (Array.isArray(targetComponent[attr]) && targetComponent[attr].length > 0) {
          targetComponent[attr].map(child_id => {
            recursiveComponent(child_id)
          })
        }
      })
    }
  }
  recursiveComponent(componentID)
  let strComponents = JSON.stringify(render.components)
  Object.entries(render.ids).map(([type, item]) => {
    item.forEach((key, index) => {
      const replace_key = `{${type}_ID_${index + 1}}`
      render.ids[type][index] = replace_key
      strComponents = strComponents.replaceAll(key, replace_key);
    });
  })
  render.components = JSON.parse(strComponents)
  return { render }
}

const findParentComponent = (components, key) => {

  const parent = Object.entries(components).filter(arr => arr[1]).map(([id, item]) => {
    const childAttr = Object.keys(item).filter(attr => attr.search('componentsID') > -1)
    let compID = []
    childAttr.forEach(attr => {
      compID = [...compID, ...item[attr]]
    });
    return { id, componentsID: compID }
  }
  ).filter(item => item.componentsID && item.componentsID.indexOf(key) > -1)[0]
  if (parent) {
    return [...findParentComponent(components, parent.id), parent.id]
  } else {
    return []
  }
}
const findParentTypeComponent = (components, key) => {
  const parent = Object.entries(components).filter(arr => arr[1]).map(([id, item]) => ({ id, componentsID: item.componentsID })).filter(item => item.componentsID && item.componentsID.indexOf(key) > -1)[0]
  if (parent) {
    const child_index = parent.componentsID.indexOf(key)
    return [...findParentTypeComponent(components, parent.id), { parent_id: parent.id, type: getComponentMeta(parent.id), child_index }]
  } else {
    return []
  }
}
const getComponentParantCell =  (components, key) => {
  let cellID = findParentComponent(components, key)[2]
  let cell = findComponent(components, cellID)
  return cell;
}

const findComponent = (components, key) => {
  return components[key];
}
const findComponentType = (components, key) => {
  const cmp = components[key];
  return (cmp && cmp.type) || undefined;
}
const isExistsComponent = (components, key) => {
  return components[key] ? true : false;
}

const genKey = (type) => {
  const randomkey = `${Math.random().toString(36).substring(4)}`;
  return `${type}${randomkey.substring(
    randomkey.length - 4,
    randomkey.length
  )}`;
}
const genUniqKey = (components, type) => {
  let key = genKey(type);
  if (components && components[key]) {
    key = genUniqKey(components, type);
  }
  return key;
}
const mock2Component = (components, render) => {
  let componentStr = JSON.stringify(render.components);
  let rootKey = ''
  Object.entries(render.ids).map(([type, item], key_index) => {
    item.forEach((key, index) => {

      let replace_prefix = SECTION.prefixKey;
      if (type.toLowerCase().includes("widget")) {
        replace_prefix = WIDGET.prefixKey;
      } else if (type.toLowerCase().includes("grid")) {
        replace_prefix = GRID.prefixKey;
      } else if (type.toLowerCase().includes("cell")) {
        replace_prefix = CELL.prefixKey;
      } else if (type.toLowerCase().includes("slide_section")) {
        replace_prefix = SLIDE_SECTION.prefixKey;
      } else if (type.toLowerCase().includes("slide_page")) {
        replace_prefix = SLIDE_PAGE.prefixKey;
      } else if (type.toLowerCase().includes("slide_container")) {
        replace_prefix = SLIDE_CONTAINER.prefixKey;
      }
      const replace_key = genUniqKey(components, replace_prefix);
      render.ids[type][index] = replace_key;
      componentStr = componentStr.replaceAll(key, replace_key);

      if (key_index == 0 && index == 0) {
        rootKey = replace_key
      }
    });
  });
  return { key: rootKey, object: JSON.parse(componentStr) }
}
const mock2Page = (siteComponents,components, render) => {
  let componentStr = JSON.stringify(render.data);
  let rootKey = ''

  Object.entries(render.ids).map(([type, item],key_index) => {
    item.forEach((key, index) => {

      let replace_prefix = SECTION.prefixKey;
      if (type.toLowerCase().includes("widget")) {
        replace_prefix = WIDGET.prefixKey;
      } else if (type.toLowerCase().includes("grid")) {
        replace_prefix = GRID.prefixKey;
      } else if (type.toLowerCase().includes("cell")) {
        replace_prefix = CELL.prefixKey;
      } else if (type.toLowerCase().includes("slide_section")) {
        replace_prefix = SLIDE_SECTION.prefixKey;
      } else if (type.toLowerCase().includes("slide_page")) {
        replace_prefix = SLIDE_PAGE.prefixKey;
      } else if (type.toLowerCase().includes("slide_container")) {
        replace_prefix = SLIDE_CONTAINER.prefixKey;
      } else if (type.toLowerCase().includes("page")) {
        replace_prefix = PAGE.prefixKey;
      } 
      let replace_key = '';
      if(type.toLowerCase().includes("page")){
        replace_key = genUniqKey(siteComponents, replace_prefix);
      }else {
        replace_key = genUniqKey(components, replace_prefix);
      }
      render.ids[type][index] = replace_key;
      componentStr = componentStr.replaceAll(key, replace_key);

      if (key_index == 0 && index == 0) {
        rootKey = replace_key
      }
    });
  });
  return { key: rootKey, object: JSON.parse(componentStr) }
}

const replaceThemeWebsite = (render, appearance, appearanceLanguage) => { 
  let temp = JSON.stringify(render);
  temp = temp.replaceAll('{BUTTON_SHAPE}', normalizeButtonShape(appearance.button.style));
  temp = temp.replaceAll('{BUTTON_FONT_SIZE}', appearanceLanguage.button.fontSize);
  temp = temp.replaceAll('{BUTTON_FONT_FAMILY}', appearanceLanguage.button.fontFamily);
  temp = temp.replaceAll('{BUTTON_FONT_COLOR}', appearance.button.fontColor);
  temp = temp.replaceAll('{BUTTON_FONT_COLOR_HOVER}', appearance.button.fontColorHover);
  temp = temp.replaceAll('{BUTTON_BACKGROUND_COLOR}', appearance.button.backgroundColor);
  temp = temp.replaceAll('{BUTTON_BACKGROUND_COLOR_ALPHA}', appearance.button.backgroundColorAlpha);
  temp = temp.replaceAll('{BUTTON_BACKGROUND_COLOR_HOVER}', appearance.button.backgroundColorHover);
  temp = temp.replaceAll('{BUTTON_BACKGROUND_COLOR_HOVER_ALPHA}', appearance.button.backgroundColorAlphaHover);
  temp = temp.replaceAll('{BUTTON_BOARDER_COLOR}', appearance.button.borderColor);
  temp = temp.replaceAll('{BUTTON_BOARDER_COLOR_ALPHA}', appearance.button.borderColorAlpha);
  temp = temp.replaceAll('{BUTTON_BOARDER_COLOR_HOVER}', appearance.button.borderColorHover);
  temp = temp.replaceAll('{BUTTON_BOARDER_COLOR_HOVER_ALPHA}', appearance.button.borderColorAlphaHover);

  Object.keys(appearanceLanguage.font).forEach(fontName => {
    temp = temp.replaceAll(`{FONT_${fontName.toUpperCase()}_FAMILY}`, appearanceLanguage.font[fontName].family);
    temp = temp.replaceAll(`{FONT_${fontName.toUpperCase()}_SIZE}`, appearanceLanguage.font[fontName].size);
    temp = temp.replaceAll(`{FONT_${fontName.toUpperCase()}_SIZE_RESPONSIVE}`, responsiveFontSize(appearanceLanguage.font[fontName].size));
    temp = temp.replaceAll(`{FONT_${fontName.toUpperCase()}_IS_BOLD}`, appearanceLanguage.font[fontName].isBold);
    temp = temp.replaceAll(`{FONT_${fontName.toUpperCase()}_IS_ITALIC}`, appearanceLanguage.font[fontName].isItalic);
    temp = temp.replaceAll(`{FONT_${fontName.toUpperCase()}_COLOR}`, appearance.font[fontName].color);
  });

  return JSON.parse(temp);
}

const normalizeButtonShape = (value) => {
  if(value === 'button_round')  return 'rounded'
  else if(value === 'button_rounder') return 'rounder'
  else if(value === 'button_square') return 'square'
  else return 'square'
}

const getCellWidth = (components, cellID) => {
  let gridID = findParentComponent(components,cellID)[1]
  let gridComponent = findComponent(components,gridID)
  let gridLayout = gridComponent.style.layout;
  let cellOrder = (gridComponent.componentsID.findIndex(obj => {return obj == cellID})) + 1
  let cellsConfig = gridLayoutConfig[gridLayout].cells
  let cellConfig = cellsConfig[cellOrder]
  return cellConfig.width;
}

const getCellParant = (components, cellID) => {
  let gridID = findParentComponent(components,cellID)[1]
  let gridComponent = findComponent(components,gridID)
  return gridComponent;
}

const getGridParent = (components, gridID) => {
  let sectionID = findParentComponent(components,gridID)[0]
  let sectionComponent = findComponent(components,sectionID)
  return sectionComponent;
}

const getSlideBlockParant =  (components, key) => {
  let sectionID = findParentComponent(components,key)[4]
  let sectionComponent = findComponent(components,sectionID)
  return sectionComponent;
}

const getSlideBlockParantCell =  (components, key) => {
  let cellID = findParentComponent(components,key)[2]
  let cellComponent = findComponent(components,cellID)
  return cellComponent;
}

const getSlideBlockParantSection =  (components, key) => {
  let sectionID = findParentComponent(components,key)[0]
  let sectionComponent = findComponent(components,sectionID)
  return sectionComponent;
}

const checkAddWidget = (sectionComponent, widgetComponent, cellWidth) => {
  const widgetType = widgetComponent.type
  const sectionLayout = sectionComponent.style.width == 'container-fluid' ? 'fluid' : 'container'
  let cellConfigs = {}
  switch (widgetType) {
    case 'SECTION_WIDGET_TEXT': 
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_FORM':
      cellConfigs = layoutConfigs[widgetType][widgetComponent.style.layout][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_IMAGE':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_IMAGE_GALLERY':
      cellConfigs = layoutConfigs[widgetType]['layout0'+widgetComponent.style.layout]['cellWidth']
      break;
    case 'SECTION_WIDGET_ALBUM':
      cellConfigs = layoutConfigs[widgetType]['layout0'+widgetComponent.style.layout]['cellWidth']
      break;
    case 'SECTION_WIDGET_CONTACT':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_CONTENT':
      cellConfigs = layoutConfigs[widgetType][widgetComponent.style.layout][sectionComponent.style.width]['cellWidth']
      break;
    case 'SECTION_WIDGET_PRODUCT':
      {
        let widgetLayout = widgetComponent.style.layout == 'slide' ? 'layoutSlide' : 'layout' + widgetComponent.style.layout;
        cellConfigs = layoutConfigs[widgetType][widgetLayout][sectionComponent.style.width]['cellWidth'];
      }
      break;
    case 'SECTION_WIDGET_INTERACTIVE':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_COUPON':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_FAQ':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_PRODUCT_BRAND':
      cellConfigs = layoutConfigs[widgetType][widgetComponent.style.layout][sectionLayout !== 'container' ? 'container-fluid' : 'container']['cellWidth']
      break;
    case 'SECTION_WIDGET_MENU_PRODUCT':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_PRODUCT_CATEGORY':
      cellConfigs = layoutConfigs[widgetType][sectionLayout]['cellWidth']
      break;
    case 'SECTION_WIDGET_QUOTATION_FORM':
      cellConfigs = layoutConfigs[widgetType][widgetComponent.style.layout][sectionLayout]['cellWidth']
      break;
    default:
      return true
  }

  if (cellWidth in cellConfigs){
    return cellConfigs[cellWidth].allow
  }
  return true // debug
}
export {
  cloneComponent,
  component2Mock,
  findParentComponent,
  getComponentMeta,
  findParentTypeComponent,
  getComponentParantCell,
  mock2Component,
  genKey,
  genUniqKey,
  findComponent,
  findComponentType,
  isExistsComponent,
  getCellWidth,
  checkAddWidget,
  getCellParant,
  getGridParent,
  getSlideBlockParant,
  getSlideBlockParantCell,
  getSlideBlockParantSection,
  replaceThemeWebsite,
  mock2Page,
}
export default {
  cloneComponent,
  component2Mock,
  findParentComponent,
  getComponentMeta,
  findParentTypeComponent,
  getComponentParantCell,
  mock2Component,
  genKey,
  genUniqKey,
  findComponent,
  findComponentType,
  isExistsComponent,
  getCellWidth,
  checkAddWidget,
  getCellParant,
  getGridParent,
  getSlideBlockParant,
  getSlideBlockParantCell,
  getSlideBlockParantSection,
  replaceThemeWebsite,
  mock2Page,
}
